module.exports = __webpack_public_path__ + "img/sample.a7e2609a.png";